import React from 'react';
import { useLanguage } from '../../../../context/LanguageContext';
import Navbar from '../../../components/navbar/ui/Navbar';
import Footer from '../../../components/footer/ui/Footer';
import ScrollToTop from '../../../components/scroll-to-top/ui/ScrollToTop';
import SEO from '../../../components/seo/SEO';
import HelpCard from '../../../components/help-card/ui/HelpCard';
import PageHeader from '../components/ui/PageHeader';
import { MobileInlineCta, MobileCtaBar } from '../../../components/mobile-cta/ui/MobileCta';
import { seoData } from '../../../../data/seoData';
import '../components/style/store-categories.css';

const PHONE = '+351219010100';
const PHONE_DISPLAY = '219 010 100';

const StorePage: React.FC = () => {
    const { language } = useLanguage();
    const pt = language === 'pt';
    
    const categories = [
        {
            name: language === 'pt' ? 'Eletricidade' : 'Electricity',
            icon: 'fas fa-bolt',
            description: language === 'pt' 
                ? 'Equipamentos elétricos e componentes para o seu veículo'
                : 'Electrical equipment and components for your vehicle'
        },
        {
            name: language === 'pt' ? 'Equipamento Interior' : 'Interior Equipment',
            icon: 'fas fa-car-side',
            description: language === 'pt'
                ? 'Acessórios e equipamentos para o interior do veículo'
                : 'Accessories and equipment for the vehicle interior'
        },
        {
            name: language === 'pt' ? 'Equipamento Exterior' : 'Exterior Equipment',
            icon: 'fas fa-car',
            description: language === 'pt'
                ? 'Equipamentos e acessórios para o exterior do veículo'
                : 'Equipment and accessories for the vehicle exterior'
        },
        {
            name: language === 'pt' ? 'Lubrificantes' : 'Lubricants',
            icon: 'fas fa-oil-can',
            description: language === 'pt'
                ? 'Óleos e lubrificantes de alta qualidade'
                : 'High quality oils and lubricants'
        },
        {
            name: language === 'pt' ? 'Manutenção' : 'Maintenance',
            icon: 'fas fa-tools',
            description: language === 'pt'
                ? 'Produtos e equipamentos para manutenção do veículo'
                : 'Products and equipment for vehicle maintenance'
        },
        {
            name: language === 'pt' ? 'Peças Técnicas' : 'Technical Parts',
            icon: 'fas fa-cog',
            description: language === 'pt'
                ? 'Peças técnicas e componentes especializados'
                : 'Technical parts and specialized components'
        },
        {
            name: language === 'pt' ? 'Pneus' : 'Tires',
            icon: 'fas fa-circle',
            description: language === 'pt'
                ? 'Pneus de todas as marcas e dimensões'
                : 'Tires from all brands and sizes'
        },
        {
            name: language === 'pt' ? 'Som, Multimédia e Sistemas de Navegação' : 'Sound, Multimedia and Navigation Systems',
            icon: 'fas fa-music',
            description: language === 'pt'
                ? 'Sistemas de som, multimédia e navegação'
                : 'Sound, multimedia and navigation systems'
        },
        {
            name: language === 'pt' ? 'Ferramentas' : 'Tools',
            icon: 'fas fa-wrench',
            description: language === 'pt'
                ? 'Ferramentas profissionais para manutenção'
                : 'Professional tools for maintenance'
        }
    ];

    return (
        <>
            <SEO 
                title={seoData.store.title}
                description={seoData.store.description}
                keywords={seoData.store.keywords}
                canonical={seoData.store.canonical}
            />
        <div className="store-page">
            <Navbar />
            <PageHeader />
                
                {/* Main Content Section */}
                <section className="store-main-section">
                    <div className="container">
                        {/* Introduction */}
                        <div className="store-intro">
                            <img
                                className="store-intro__img"
                                src="/assets/logo/store/loja_1.webp"
                                alt={pt ? 'Loja Roady' : 'Roady store'}
                                loading="lazy"
                            />
                            <h1 className="store-intro__title">
                                {language === 'pt'
                                    ? <>Peças e Acessórios Automóvel<br />na Malveira</>
                                    : <>Car Parts and Accessories<br />in Malveira</>}
                            </h1>
                            <p className="store-intro__description">
                                {language === 'pt'
                                    ? 'Peças, eletricidade, equipamento interior e exterior, produtos de manutenção, ferramentas e acessórios para o seu automóvel.'
                                    : 'Parts, electrics, interior and exterior equipment, maintenance products, tools and accessories for your car.'}
                            </p>
                            <MobileInlineCta
                                phone={PHONE}
                                phoneDisplay={PHONE_DISPLAY}
                                quoteHref="/orcamento"
                                source="store_page"
                                pt={pt}
                            />
                        </div>

                        {/* Categories Grid */}
                        <div className="store-categories-grid">
                            {categories.map((category, index) => (
                                <div key={index} className="store-category-item">
                                    <div className="store-category-item__icon-wrapper">
                                        <i className={`${category.icon} store-category-item__icon`}></i>
                                    </div>
                                    <h3 className="store-category-item__name">{category.name}</h3>
                                    <p className="store-category-item__description">{category.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Orçamento Card Section */}
                <section className="store-budget-section">
                    <div className="container">
                <HelpCard />
                    </div>
            </section>

            <Footer />
            <ScrollToTop />
            <MobileCtaBar
                phone={PHONE}
                phoneDisplay={PHONE_DISPLAY}
                quoteHref="/orcamento"
                source="store_page"
                pt={pt}
            />
        </div>
        </>
    );
};

export default StorePage;
